import { createContext, useContext } from 'react';
import { type GitlabInstallationV2ContextValue } from './types';

export const GitlabInstallationV2Context = createContext<
  GitlabInstallationV2ContextValue | undefined
>(undefined);

/**
 * Access the v2 GitLab installation wizard context (the connect URL).
 *
 * @returns The v2 wizard context value (gitlabUrl).
 * @throws Error if used outside GitlabInstallationV2Context.Provider
 */
export const useGitlabInstallationV2 = () => {
  const context = useContext(GitlabInstallationV2Context);

  if (!context) {
    throw new Error(
      'useGitlabInstallationV2 must be used within GitlabInstallationV2Context.Provider',
    );
  }

  return context;
};
